import React from 'react';

export default function StatsCard({ icon, label, value, sub, color = '#db3131' }) {
  return (
    <div className="stats-card">
      <div className="stats-card-icon" style={{ background: `${color}22`, color }}>
        {icon}
      </div>
      <div className="stats-card-info">
        <div className="stats-card-value">{value}</div>
        <div className="stats-card-label">{label}</div>
        {sub && <div className="stats-card-sub">{sub}</div>}
      </div>
    </div>
  );
}
